import { Switch } from 'antd';
import styled from 'styled-components';

const SwitchDisabled = styled(Switch)`
  cursor: default !important;
  opacity: 1;
  * {
    opacity: 1;
    cursor: default !important;
  }
`;

export { Switch, SwitchDisabled };
